import React, { useContext, useEffect, useState } from "react";
import AppContext from "../context/AppContext";
import translations from "../components/common/Translations";
import CommonButton from "../components/common/CommonButton";
import { hasScreenAccess, PERMISSIONS_CHANGED_EVENT } from "../utils/permissions";

const ProtectedRoute = ({
  children,
  privilegesRequired,
  screenCode,
  requiredPermission = "canView",
}) => {
  const { user, langMode } = useContext(AppContext);
  const [permissionVersion, setPermissionVersion] = useState(0);

  useEffect(() => {
    const handlePermissionsChanged = () => {
      setPermissionVersion((value) => value + 1);
    };
    window.addEventListener(PERMISSIONS_CHANGED_EVENT, handlePermissionsChanged);
    return () => window.removeEventListener(PERMISSIONS_CHANGED_EVENT, handlePermissionsChanged);
  }, []);

  void permissionVersion;

  const hasRequiredPrivileges = Array.isArray(privilegesRequired)
    ? Boolean(user) && privilegesRequired.every((privilege) => user?.[privilege] !== false)
    : true;

  const hasRequiredScreenPermission = !screenCode
    ? true
    : (Array.isArray(screenCode) ? screenCode : [screenCode]).some((code) =>
        hasScreenAccess(code, requiredPermission)
      );

  const isAllowed = hasRequiredPrivileges && hasRequiredScreenPermission;

  if (isAllowed) {
    return children;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="rounded-lg bg-white p-5 shadow-xl">
        <h2 className="text-sm font-semibold text-red-600">
          {translations[langMode].accessdenied}
        </h2>
        <p className="texts-sm">{translations[langMode].nopermission}</p>
        <CommonButton
          variant="primary"
          tooltipText={translations[langMode].requestreporbasedonfilter}
          tooltipPosition="top"
          style={{ whiteSpace: "nowrap" }}
          onClick={() => window.history.back()}
        >
          {translations[langMode].goback}
        </CommonButton>
      </div>
    </div>
  );
};

export default ProtectedRoute;
